import Reveal from "@/components/Reveal";
import { OrbitMark } from "@/components/GlobeArt";

export default function PageHero({ eyebrow, title, sub, children }) {
  return (
    <section className="bg-platinum pt-32 sm:pt-36 lg:pt-44 pb-12 sm:pb-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="flex items-center gap-2 font-display text-xs font-bold uppercase tracking-[0.25em] text-cobalt">
            <OrbitMark className="h-4 w-4" />
            {eyebrow}
          </p>
          <h1 className="mt-5 max-w-4xl font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-ink">
            {title}
          </h1>
          {sub && (
            <p className="mt-6 max-w-2xl text-lg sm:text-xl leading-relaxed text-ink/75">{sub}</p>
          )}
          {children}
          <div className="mt-10 h-px w-full bg-silver/60" />
        </Reveal>
      </div>
    </section>
  );
}
